// src/components/common/ConfirmModal.tsx

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: (...args:any[]) => void | Promise<void>;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  isProcessing?: boolean;
  children?: React.ReactNode;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isProcessing = false,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <Dialog 
      open={isOpen} 
      onOpenChange={() => !isProcessing && onCancel()}
      modal={true}
    >
      <DialogContent className="z-50">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <p className="mb-4 text-gray-600">{message}</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-200"
          >
            {cancelText}
          </button>
          <button
            disabled={isProcessing}
            onClick={onConfirm}
            className={`px-4 py-2 rounded hover:bg-red-600 transition duration-200 ${isProcessing ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-500 text-white'}`}
          >
            {isProcessing ? 'Processing...' : confirmText}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
